import React from 'react';
import './index.scss';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';

export default class AddDialog extends React.Component {

    render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby="form-dialog-title"
                >
                <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
                {this.props.children}
                
            </Dialog>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/global/addDialog/index.js